import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { getCategoryTitle } from '@classifieds-sell/datalayer';
import { Subject } from 'rxjs';
import { getFullAddress } from '../../../../helpers/address.helper';
import { StepIds } from '../../../../models/property-step/property-step-model';
import { DraftFacade } from '@classifieds-sell/state';
import { PropertySectionBase } from '../../../property-section-base';

@Component({
    selector: 'property-summary-page-property-information-section',
    templateUrl: './summary-page-property-information-section.component.html',
    styleUrls: ['./summary-page-property-information-section.component.scss']
})
export class SummaryPagePropertyInformationSectionComponent
    extends PropertySectionBase
    implements OnInit, OnDestroy {
    stepIds = StepIds;
    category: string;
    address: string;
    landArea: string;

    private _destroyed$: Subject<void> = new Subject<void>();

    constructor(
        draftFacade: DraftFacade,
        private _changeDetectorRef: ChangeDetectorRef
    ) {
        super(draftFacade);
    }

    ngOnDestroy(): void {
        super.onDestroy();
        this._destroyed$.next();
    }

    ngOnInit(): void {
        super.onInit(() => {
            this.category = getCategoryTitle(this.categoryId);

            this.address = getFullAddress(
                this.draftData.propertyInformation,
                this.metadata.regions
            );

            this.landArea = this.draftData.propertyInformation.landArea || this.draftData.propertyInformation.landArea === 0
                ? this.draftData.propertyInformation.landArea.toLocaleString()
                : '';

            this._changeDetectorRef.markForCheck();
        });
    }

    isValid(): boolean {
        return true;
    }

    dirty(): boolean {
        return false;
    }
}
